<template id="Conformite">
	<div>
		<div class="iframe" v-html="iframe">
		</div>
	</div>
</template>

<script>
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
export default {
	name: 'Modele',
	data () {
		return {
			iframe:"",
			documents_list:[],
      		documents:[],
      		icons:[],
      		calcul_prix:[],
      		prix:"",
      		taxes:"",
      		description1:"",
      		description2:"",
      		cas_particuliers:false,
      		isActive:[],
      		btns:[]
		}
	},
	methods: {
	},
	mounted () {
		if(Object.keys(this.$store.state.static).length === 0){
			firebase.auth().signInAnonymously()
      		.then(() => {
				// console.log("object empty")
				fb.db.collection('documents').doc("Conformité").get()
	  			.then(res => {
		  			this.iframe=res.data().iframe
		  		})
		  	})
		}else{
			// console.log("object not very empty :/")
			var doc = this.$store.state.static["Conformité"]
			this.iframe=doc.iframe
		}
  		
	},
	destroyed () {
			this.iframe=""
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Conformite.vue